import { render, staticRenderFns } from "./MainButtonDecorRight.vue?vue&type=template&id=d41df154"
import script from "./MainButtonDecorRight.vue?vue&type=script&lang=js"
export * from "./MainButtonDecorRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports